import { s as surfaceDarkStyles } from './surfaceDark-CjzXgz54.js';

const surfaceDarkInfoStyles = {
  ...surfaceDarkStyles,
  surface: {
    backgroundColor: '#018485'
  }
};

export { surfaceDarkInfoStyles as s };
//# sourceMappingURL=surfaceDarkInfo-nak4bJe3.js.map
